import { c as _c } from "react/compiler-runtime";
import { useRef, useCallback, useState } from 'react';
import { Duration } from '@/lib/duration';
export const COPY_TEXT_TIMEOUT = Duration.from({
  seconds: 1.5
}).toMillis();
export function useCopyToClipboard() {
  const $ = _c(4);
  const [copied, setCopied] = useState(false);
  const [recentlyCopied, setRecentlyCopied] = useState(false);
  const timerRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = value => {
      setCopied(true);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      navigator.clipboard.writeText(value);
      setRecentlyCopied(true);
      timerRef.current = setTimeout(() => {
        setRecentlyCopied(false);
      }, COPY_TEXT_TIMEOUT);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const copy = t0;
  let t1;
  if ($[1] !== copied || $[2] !== recentlyCopied) {
    t1 = {
      copied,
      recentlyCopied,
      copy
    };
    $[1] = copied;
    $[2] = recentlyCopied;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}